import React, { Fragment } from 'react';
import style from './LoadingIndicator.module.scss'
import { connect } from 'react-redux';
import { AppState } from '../../../store';
import { SystemState } from '../../../store/system/types';
import { Col, Spin } from 'antd';
import load from '../../images/loadGlowSkiinn.gif';
interface LoadingIndicatorProps {
    system: SystemState
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = (props: LoadingIndicatorProps) => {
    return props.system.showLoading ? (
        <div className={style["loading-indicator"]}>
            <img src={load} alt={`BtnBack`} />
        </div>
    )
        :
        (<Fragment></Fragment>);
};

const mapStateToProps = (state: AppState) => ({
    system: state.system
});

export default connect(mapStateToProps)(LoadingIndicator);
